import {
  COVERTREE_EMAIL_ADDRESS,
  SALES_EMAIL_ADDRESS,
} from "@covertree/consts";
import { InfoDisclaimerBox } from "@covertree/ui/content";
import { Link } from "@mui/material";

export function CYQDisclaimer({
  isInternalAgent,
}: {
  isInternalAgent?: boolean;
}) {
  return (
    <InfoDisclaimerBox dataTestId="disclaimer-box-cyq-checkout" mt={3}>
      Changes to the policy cannot be made on this screen. For assistance with
      reviewing or updating coverages, please contact the IA team at{" "}
      {isInternalAgent ? (
        <Link color="secondary" href={`mailto:${COVERTREE_EMAIL_ADDRESS}`}>
          {COVERTREE_EMAIL_ADDRESS}
        </Link>
      ) : (
        <Link color="secondary" href={`mailto:${SALES_EMAIL_ADDRESS}`}>
          {SALES_EMAIL_ADDRESS}
        </Link>
      )}
    </InfoDisclaimerBox>
  );
}
